import React, { useState, useEffect } from 'react';
import { Menu, X, Code } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'experience', label: 'Experience' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled
          ? 'backdrop-blur-md border-b'
          : ''
      }`}
      style={{
        background: isScrolled ? 'var(--bg-primary)' : 'transparent',
        borderColor: isScrolled ? 'var(--border)' : 'transparent'
      }}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('home')}
            className="flex items-center space-x-2 group cursor-pointer"
          >
            <div className="w-10 h-10 rounded-full flex items-center justify-center border transition-all"
              style={{
                background: 'var(--accent)',
                borderColor: 'var(--accent)'
              }}
            >
              <Code className="h-5 w-5" style={{ color: '#000' }} />
            </div>
            <span className="text-xl font-bold hidden md:block" style={{ 
              color: 'var(--text-primary)',
              fontFamily: 'JetBrains Mono, monospace' 
            }}>
              Prathamesh Deshpande
            </span>
            <span className="text-xl font-bold block md:hidden" style={{ 
              color: 'var(--text-primary)',
              fontFamily: 'JetBrains Mono, monospace' 
            }}>
              PD
            </span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="text-base font-semibold transition-colors relative group"
                style={{
                  color: 'var(--text-secondary)',
                  fontFamily: 'JetBrains Mono, monospace'
                }}
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 group-hover:w-full transition-all duration-300"
                  style={{ background: 'var(--accent)' }}
                ></span>
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg transition-colors"
            style={{ color: 'var(--text-primary)' }}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-6 space-y-2" style={{ background: 'var(--bg-primary)' }}>
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left px-4 py-3 rounded-lg transition-colors font-medium"
                style={{
                  color: 'var(--text-secondary)',
                  fontFamily: 'JetBrains Mono, monospace'
                }}
              >
                {link.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
